import Page from "../components/Layout/Page";

export default function TermsOfService() {
  return (
    <Page title="Terms of Service">
      <div id="otnotice-66e44f0e-35b6-439a-8a3f-d97506091451" className="mt-5 prose max-w-none text-gray-500 prose-a:text-sky-600 prose-h2:text-sky-600"></div>
    </Page>
  )
}